import React from "react";
import { Link } from "react-router-dom";

export default function Work() {
  return (
    <div className="py-20 text-center flex flex-col justify-center items-center space-y-4 text-white text-xl uppercase">
      <div className="big-screen">
        <Link to="/webapps">
          <div className="cards1 flex flex-col justify-center items-center">
            <h2 className="font-semibold text-4xl pb-8">Web Apps</h2>
            <p>View my Desktop Apps</p>
          </div>
        </Link>
        <div>
          <Link to="/experience">
            <div className="cards flex flex-col justify-center items-center">
              <h2 className="font-semibold text-4xl pb-8">Experience</h2>
              <p>Check my Experience</p>
            </div>
          </Link>
          <Link to="/articles">
            <div className="cards cardphoto flex flex-col justify-center items-center">
              <h2 className="font-semibold text-4xl pb-8">Articles</h2>
              <p>Read my articles</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
}

// <div className="background-work">
//   <div className="work-wrapper">
//     <div className="box-container">
//       <h2 className="box-title">Projects</h2>
//       <p className="box-subtitle">Built & designed.</p>
//       <Link to="/projects">
//         <button className="work-btn">Check my Work &#8594;</button>
//       </Link>
//     </div>
//     <div className="box-container">
//       <h2 className="box-title">Articles</h2>
//       <p className="box-subtitle">Marketing content articles.</p>
//       <Link to="/articles">
//         <button utton className="work-btn">
//           Read my articles &#8594;
//         </button>
//       </Link>
//     </div>
//   </div>
// </div>
